$(document).ready(function () {

  $("li:first-child").addClass("first");
  $("li:last-child").addClass("last");

  $('[href="#"]').attr("href", "javascript:;");

  $(".menu-Bar").click(function () {
    // $(this).toggleClass("open");
    $(".menuWrap").toggleClass("open");
    $("body").toggleClass("ovr-hiddn");
  });
  
 $(".close-menu-btn").click(function () {
    // $(this).toggleClass("open");
    $(".menuWrap").toggleClass("open");
    $("body").toggleClass("ovr-hiddn");

   $('.menu').removeClass("mega-menu-open");
   $('.menu li').removeClass("this-menu-mega-open")
  });


  $(".header-menu-btn").click(function () {
    // $(this).toggleClass("open");
    $(".new-megamenu-wrapper").addClass("new-mm-active");
    $("body").addClass("ovr-hiddn");

    
  });


    $(".close-new-mm").click(function () {
    // $(this).toggleClass("open");
    $(".new-megamenu-wrapper").removeClass("new-mm-active");
    $("body").removeClass("ovr-hiddn");

    
  });



  $(".new-megamenu-inner-accordion-btn").on("click", function(){


    let mainParent = $(this).parent().parent();
    
    if(!$(mainParent).hasClass("new-mega-menu-accordion-active"))
    {
      $('.new-megamenu-items li').siblings().removeClass("new-mega-menu-accordion-active");
      $('.new-megamenu-items li').siblings().find('.new-megamenu-inner-items').slideUp();
      
      $(mainParent).addClass("new-mega-menu-accordion-active");
      $(mainParent).find('.new-megamenu-inner-items').slideDown();
      
    }

  })

    $(document).ready(function() {
  $('.new-megamenu-wrapper').on('click', function(event) {
    if (!$(event.target).closest('.new-megamenu-inner').length) {
      // Perform your action here
      console.log('Clicked outside new-megamenu-inner');
      $(".new-megamenu-wrapper").removeClass("new-mm-active");
      $("body").removeClass("ovr-hiddn");
      // Example action: Hide the menu
      // $('.new-megamenu-wrapper').hide();
    }
  });
});


  


  /* Tabbing Function */
  $("[data-targetit]").on("click", function (e) {
    $(this).addClass("active");
    $(this).siblings().removeClass("active");
    var target = $(this).data("targetit");
    $("." + target)
      .siblings('[class^="box-"]')
      .hide();
    $("." + target).fadeIn();
    $(".shop-slider,.tag-slider").slick("setPosition", 0);
  });


  // home shop tabbing
  $('.shop-flavour-dropdown').on('change', function() {
    
    // alert( $(this).find(":selected").val() );
    var target = $(this).find(":selected").val();
    $("." + target)
      .siblings('[class^="box-"]')
      .hide();
    $("." + target)
      .siblings().removeClass('shop-active-product')
    $("." + target).fadeIn();
    $("." + target).addClass("shop-active-product")
    
});

  // Accordian
  $(".accordian h4").click(function () {
    $(".accordian li").removeClass("active");
    $(this).parent("li").addClass("active");
    $(".accordian li div").slideUp();
    $(this).parent("li").find("div").slideDown();
  });

     // Accordian new
    $(".accordian-support h4").click(function() {

      
        $(".accordian-support li").removeClass("active");
      
        $(this)
            .parent("li")
            .addClass("active");

        $(".accordian-support li div").slideUp();

      $(this)
            .parent("li")
            .find("div")
            .slideDown();

      
    });

 // Accordian product page
    $(".product-page-accordion-activator").click(function() {
    var $parentLi = $(this).parent();
    var $nextDiv = $(this).next();
    
    if ($parentLi.hasClass("active")) {
        // If already active, remove the active class and slide up
        $parentLi.removeClass("active");
        $nextDiv.slideUp();
    } else {
        // Close other accordions
        $(".product-page-accordions>li").removeClass("active");
        $(".product-page-accordions>li>div").slideUp();

        // Open the clicked accordion
        $parentLi.addClass("active");
        $nextDiv.slideDown();
    }
});
  
  $("li.dropdown-nav").hover(function () {
    $(this).children("ul").stop(true, false, true).slideToggle(300);
  });





  $(".index-slider").slick({
        dots: false,
      arrows:true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
      autoplay:true,
      autoplaySpeed:3500,
    pauseOnFocus:false,
    pauseOnHover:false,
      prevArrow: "<button class='hero-slider-btn hero-slider-left'><i class='fa fa-chevron-left'></i></button>",
    nextArrow: "<button class='hero-slider-btn hero-slider-right'><i class='fa fa-chevron-right'></i></button>",
    });

  // $(".index-slider").slick({
  //   dots: true,
  //   arrows:false,
  //   infinite: true,
  //   speed: 600,
  //   slidesToShow: 1,
  //   autoplay:true,
  //   autoplaySpeed:5500,
  //   pauseOnHover:false,
  //   pauseOnFocus:false,
  //   // prevArrow: $('.prev'),
  //   // nextArrow: $('.next')
  // });

  $(".shop-slider").slick({
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll:4,
    prevArrow:
      '<button class="shop-slider-left shop-slider-btn"><i class="fa fa-chevron-left"></i></button>',
    nextArrow:
      '<button class="shop-slider-right shop-slider-btn"><i class="fa fa-chevron-right"></i></button>',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
       {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
      breakpoint: 1366,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
      {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
      {
        breakpoint:767,
        settings: "unslick"
      }
  ]
  });

  $(".tag-slider").slick({
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll:3,
    prevArrow:
      '<button class="shop-slider-left tag-slider-left shop-slider-btn"><i class="fa fa-chevron-left"></i></button>',
    nextArrow:
      '<button class="shop-slider-right tag-slider-right shop-slider-btn"><i class="fa fa-chevron-right"></i></button>',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
       {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
      breakpoint: 1366,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
      {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
      {
        breakpoint:767,
        settings: "unslick"
        // settings: {
        // slidesToShow: 2,
        // slidesToScroll: 2
        // }
      }
  ]
  });

  $(".contest-reveal-slider").slick({
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll:1,
    prevArrow:
      '<button class="shop-slider-left shop-slider-btn"><i class="fa fa-chevron-left"></i></button>',
    nextArrow:
      '<button class="shop-slider-right shop-slider-btn"><i class="fa fa-chevron-right"></i></button>',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      },
      {
      breakpoint: 1366,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
      {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
      {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
  ]
  });

  // $(".promo-slider").slick({
  //   dots: false,
  //   arrows: false,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   autoplay: true,

  //   responsive: [
  //     {
  //       breakpoint: 825,
  //       settings: {
  //         useTransform: false,
  //       },
  //     },
  //   ],
  // });

  $('.bundle-notif-icon').on('click',function(){
  $('.popuptax-bundles').addClass('active');
})
 
$('.close-tax').on('click',function(){
  $('.popuptax-bundles').removeClass('active');
})

  /* Top Scroll */
  $('body').on('click', '.shop-category-box,.shopbt,.hero-scroll', function() {
      var scrollTarget = $(this).data("scroll");
    // console.log(scrollTarget)
      goToScroll(scrollTarget);
  });
});

$(window).on("scroll touchmove", function() {
    $(".header-sticky").toggleClass("sticky-active", $(document).scrollTop() > 400);
});


var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});


$(window).on('load', function() {

    $(".tag-slider>li").slice(0, 4).addClass('display');
   
  
  // Select the list container and set an event listener for the "load more" button
  $('.tags-slider-container').on('click', '.load-more-button', function() {


        $(this).parent().find(".tag-slider>li:hidden").slice(0, 4).slideDown()
      .css("display", "inline-block");;
        if ($(this).parent().find(".tag-slider>li:hidden").length == 0) {
            $(this).parent().find(".load-more-button").addClass('hide-btn-now');
        }  

    

    
  });


  

  
//embed widget additions


   $('body').on('click','.new-megamenu-flex-wrap.pb-widget-trigger',function(){    
     console.log("CLICKEITY");
      // $('.widget-trigger').toggleClass("widget-trigger-activated");
      // $('.peak-rewards-widget-page-main').toggleClass("widget-panel-active");


     if($('.new-megamenu-wrapper').hasClass("new-mm-active"))
     {
       console.log("Has class");
       $('.new-megamenu-wrapper').removeClass("new-mm-active")
       $('body').removeClass("ovr-hiddn")
     }
      
     // $('.peak-rewards-widget-page-main').fadeIn();   
   });


   //facebook share fix

          // Select the anchor tag
        var shareLink = $('.refferal-share-links li:nth-child(2) a');

        // Get the current onclick attribute
        var onclickAttr = shareLink.attr('onclick');

        // Extract the URL from the share function call
        var urlMatch = onclickAttr.match(/share\('([^']*)',''\);/);

        if (urlMatch && urlMatch[1]) {
            var url = urlMatch[1];

            // Remove any occurrences of 'https://'
            var newUrl = url.replace('https://', '');

            // Prepend 'https://' correctly
            newUrl = 'https://' + newUrl;

            // Construct the new onclick attribute
            var newOnclickAttr = "share('" + newUrl + "','');";

            // Update the onclick attribute
            shareLink.attr('onclick', newOnclickAttr);
        }
  
});


  const headerActions = $(".menu-actions-bar");




  //home-shop S pods
  const shopImg = $('.home-shop-action-btns-S-Compatible-Pods');
  const shopDropdown = $('.home-shop-flavour-wrap-mobile-S-Compatible-Pods');
  const shopTitle = $('.home-shop-left-S-Compatible-Pods')
  const shopFlavourTagTitle = $(".flavour-tags-wrap-mobile-S-Compatible-Pods");

    //home-shop X pods
  const shopImgX = $('.home-shop-action-btns-LEX-Pods-10000');
  const shopDropdownX = $('.home-shop-flavour-wrap-mobile-LEX-Pods-10000');
  const shopTitleX = $('.home-shop-left-LEX-Pods-10000')
  const shopFlavourTagTitleX = $(".flavour-tags-wrap-mobile-LEX-Pods-10000");



/* RESPONSIVE JS */
if ($(window).width() < 767) {

  $(".menuWrap").prepend(headerActions)



  //quick shop mobile
  
  $(shopImg).insertAfter( ".home-shop-flavour-profile-S-Compatible-Pods" );
  $(shopTitle).insertAfter( ".home-shop-center-S-Compatible-Pods" );
  $(".box-qshop-mobile-dropdown-holder-S-Compatible-Pods").append(shopDropdown);

  // $(".flavour-tags-wrap-mobile-S-Compatible-Pods").prepend(shopFlavourTagTitle);

  $(shopImgX).insertAfter( ".home-shop-flavour-profile-LEX-Pods-10000" );
  $(shopTitleX).insertAfter( ".home-shop-center-LEX-Pods-10000" );
  $(".box-qshop-mobile-dropdown-holder-X-Compatible-Pods").append(shopDropdownX);




  




  //menu back button

  $('.megamenu-dropdown').append("<button class='menu-back' type='button'><i class='fa fa-chevron-left'></i>Back</button>")


  // $('.menu>li>a').attr("role","button");
  
}

$(function() {
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 600) {
            $('.shopbt').addClass('shopbt-visible');
           
        } else {
            $('.shopbt').removeClass('shopbt-visible');
           
        }

    });
});





//menu mobile functionality

if ($(window).width() < 767) {
  
$('.menu>li>a').on('touchstart', function(){
  // e.preventDefault();
  $(".menu").addClass("mega-menu-open");
  $(this).parent().addClass("this-menu-mega-open");
  
})


$('.menu-back').on('click', function(){
  // console.log('click')
  $('.menu').removeClass("mega-menu-open");
   $('.menu li').removeClass("this-menu-mega-open")
  
})

}




//contest input radios


$(".fsr-box").on('click',function(){
  $(this).parent().siblings().removeClass("fsr-active");
  $(this).parent().addClass("fsr-active");
  console.log('fsr-check');
  $(this).find("input[type='radio']").prop("checked", true);

  var thisBoxImg = $(this).find('img').attr("src");

  $('#selected-flavour-img').attr("src", thisBoxImg);

  
})




//mega menu css
if ($(window).width() > 767) {
  
  $(".menu>li").on("mouseenter", function() {
  
      $(this).siblings().removeClass("mm-active");
  
      $(this).addClass("mm-active");
      $('.header-non-sticky header').addClass("dropdown-active");
  
  });
  
  $(".menu>li").on("mouseleave", function() {
    
     $(this).removeClass("mm-active");
    $('.header-non-sticky header').removeClass("dropdown-active");
  
  });
  

}


function goToScroll(e) {
  $("html, body").animate(
    {
      scrollTop: $("." + e).offset().top - 75,
    },
    1000
  );
}